import { ACTION_TYPES } from 'store/common/constants/actionsTypes'
import { isOwnReducerAction } from 'utils/helpers/store/store'
import { Action, Meta } from 'types/store'

type State = Record<
  string,
  {
    meta: Meta
    pages: any
  }
>
export const storeEntityStaticsCreator =
  (staticEntityName: string) =>
  (state: State = {}, action: Action = {}) => {
    const { type, data = {} } = action

    if (!isOwnReducerAction(staticEntityName, data)) {
      return state
    }

    switch (type) {
      case ACTION_TYPES.ITEM_STATIC_FETCH_SUCCESS: {
        return {
          ...state,
          ...data[staticEntityName],
        }
      }

      default:
        return state
    }
  }
